export default {
  button: {
    margin: '0 5px'
  }
}
